import { Form } from 'react-bootstrap';
import { FaBarcode, FaCreditCard, FaQrcode } from 'react-icons/fa';

/**
 * Seletor de tipo de pagamento
 */
export const BillingTypeSelector = ({ value, onChange }) => {
  return (
    <div className="billing-type-selector">
      <h5 className="mb-3">Forma de Pagamento</h5>
      
      <Form.Check 
        type="radio"
        id="credit-card"
        name="billingType"
        value="CREDIT_CARD"
        checked={value === 'CREDIT_CARD'}
        onChange={(e) => onChange(e.target.value)}
        label={
          <div className="d-flex align-items-center">
            <FaCreditCard className="me-2 text-primary" size={20} />
            <div>
              <strong>Cartão de Crédito</strong>
              <br />
              <small className="text-muted">Aprovação imediata</small>
            </div>
          </div>
        }
        className="mb-3 p-3 border rounded"
        style={{ cursor: 'pointer' }}
      />
      
      <Form.Check 
        type="radio"
        id="boleto"
        name="billingType"
        value="BOLETO"
        checked={value === 'BOLETO'}
        onChange={(e) => onChange(e.target.value)}
        label={
          <div className="d-flex align-items-center">
            <FaBarcode className="me-2 text-warning" size={20} />
            <div>
              <strong>Boleto Bancário</strong>
              <br />
              <small className="text-muted">Aprovação em até 3 dias úteis</small>
            </div>
          </div>
        }
        className="mb-3 p-3 border rounded"
        style={{ cursor: 'pointer' }}
      />
      
      <Form.Check 
        type="radio"
        id="pix"
        name="billingType"
        value="PIX"
        checked={value === 'PIX'}
        onChange={(e) => onChange(e.target.value)}
        label={
          <div className="d-flex align-items-center">
            <FaQrcode className="me-2 text-success" size={20} />
            <div>
              <strong>PIX</strong>
              <br />
              <small className="text-muted">Aprovação instantânea</small>
            </div>
          </div>
        }
        className="mb-3 p-3 border rounded"
        style={{ cursor: 'pointer' }}
      />
    </div>
  );
};
